var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "#1F1F1F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5217 37.5C88.0217 37 87.3217 36.7999 86.6217 36.7999H66.9217V28.4C66.9217 19.2 59.4217 11.7 50.2217 11.7C41.0217 11.7 33.5217 19.2 33.5217 28.4V36.7999H13.8217C13.2217 36.7999 12.4217 36.7999 11.9217 37.5C11.4217 38 11.2217 38.7 11.3217 39.4L18.4217 78.2C19.4217 83.8999 24.4217 88.1 30.2217 88.2H70.3217C76.1217 88.1 81.0217 83.7999 82.1217 78.1L89.2217 39.4C89.2217 38.7 89.0217 38 88.5217 37.5ZM38.5217 28.5C38.5217 22.1 43.7217 16.8 50.2217 16.8C56.7217 16.8 61.9217 22 61.9217 28.5V36.9H38.5217V28.5ZM77.0217 77.5C76.4217 80.8 73.6217 83.2 70.2217 83.2H30.2217C26.9217 83.2 24.0217 80.8 23.4217 77.5L16.8217 41.9H83.6217L77.0217 77.5Z",
    strokeWidth: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4217 60.3C65.8217 60.3 66.9217 59.2 66.9217 57.8V52.1C66.9217 50.7 65.8217 49.6 64.4217 49.6C63.0217 49.6 61.9217 50.7 61.9217 52.1V57.8C61.9217 59.2 63.0217 60.3 64.4217 60.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0217 60.3C37.4217 60.3 38.5217 59.2 38.5217 57.8V52.1C38.5217 50.7 37.4217 49.6 36.0217 49.6C34.6217 49.6 33.5217 50.7 33.5217 52.1V57.8C33.5217 59.2 34.6217 60.3 36.0217 60.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.4864b8ab82c508640cdbadca34e64aa4.svg";
export { ForwardRef as ReactComponent };